import { debugLogReducer } from "../helpers/debugHelper";
import { types } from "../types/types";

const initialState = {
  catalogType: {},
  catalogTypes: [],
  catalogTypesP: [],
  catalogTypesS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
};
export const catalogTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CATALOG_TYPE_SELECT:
      return {
        ...state,
        catalogType: action.payload,
      };

    case types.CATALOG_TYPE_UPDATE:
      if (state.catalogTypesS.length > 0) {
        return {
          ...state,
          catalogTypesS: state.catalogTypesS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          catalogTypesP: state.catalogTypesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          catalogTypesP: state.catalogTypesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.CATALOG_TYPE_DELETE:
      if (state.catalogTypesS.length > 0) {
        return {
          ...state,
          catalogTypesS: state.catalogTypesS.filter((usr) => usr.id !== action.payload),
          catalogTypesP: state.catalogTypesP.filter((usr) => usr.id !== action.payload),
          catalogType: {},
        };
      } else {
        return {
          ...state,
          catalogTypesP: state.catalogTypesP.filter((usr) => usr.id !== action.payload),
          catalogType: {},
        };
      }

    case types.CATALOG_TYPE_START_LOADING:
      debugLogReducer(":: CATALOG_TYPE_START_LOADING", {catalogTypes:action.payload})
      return {
        ...state,
        catalogTypes: action.payload,
      };

    case types.CATALOG_TYPE_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogTypesP: action.payload.catalogTypesP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.CATALOG_TYPE_START_SEARCH:
      return {
        ...state,
        catalogTypesS: action.payload,
      };

    case types.CATALOG_TYPE_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogTypesS: action.payload.catalogTypesP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.CATALOG_TYPE_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        catalogTypesS: [],
      };

    case types.CATALOG_TYPE_CLEAN:
      return {
        ...state,
        catalogType: {},
      };

    case types.CATALOG_TYPE_START_REGISTER:
      return {
        ...state,
        catalogType: action.payload,
      };

    case types.CATALOG_TYPE_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    default:
      return state;
  }
};
